import { FundraisingTypeList } from 'src/models/FundraisingModel';
import {
  defaultFundraisingAmbassadors,
  defaultFundraisingAssets,
  defaultFundraisingInfo,
  defaultFundraisingMatching,
  defaultFundraisingNotifications,
  defaultFundraisingProducts,
  fundraisingBooleans,
  FundraisingSections,
} from 'src/constants/FundraisingTypes';

// When you work with incompetent programmers, aka David, you have to write convulated code
// Sorry.

export const denormalizeFundraisingSection = (
  type: FundraisingSections,
  object: FundraisingTypeList,
): FundraisingTypeList => {
  const defaults: Record<FundraisingSections, FundraisingTypeList> = {
    info: defaultFundraisingInfo,
    matching: defaultFundraisingMatching,
    products: defaultFundraisingProducts,
    ambassadors: defaultFundraisingAmbassadors,
    notifications: defaultFundraisingNotifications,
    assets: defaultFundraisingAssets,
  };

  const merged = {
    ...defaults[type],
    ...object,
  };

  return fundraisingBooleans[type].reduce<FundraisingTypeList>(
    (acc, key) => ({ ...acc, [key]: !!merged[key] }),
    merged,
  );
};
